import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  CasRHFTextField,
  CasRHFAutocompleteAsync,
  CasRHFSelect,
  CasStackRow,
} from 'src/compass/shared/components';
import { CasRHFRiskManagerSelect } from 'src/compass/application/general/components/CasRiskManagerSelect';
import { CasRHFRiskWithSalesManagerSelect } from 'src/compass/application/general/components/CasRiskWithSalesManagerSelect';
import { CasRHFSourceSelect } from 'src/compass/application/general/components/CasSourceSelect';
import { Terms } from 'src/compass/shared/util/terms';

type Props = {
  /*
    Edit passes the customer's Risk Managers, and the Service Owner must be one of them (the
    same rule as the Customers page's Service Owner dialog). Add has none to offer - a new
    customer has no accounts yet - and neither does an existing one without Risk Managers, so
    both pick from every Risk Manager and Bus Dev employee instead.
  */
  riskManagers?: { id: number; name: string }[];
};

export default function CustomerFormFields({ riskManagers }: Props) {
  const triggerFields = ['sourceEmployeeId', 'sourceId'];

  const { control, trigger } = useFormContext();

  const [sourceEmployeeId, sourceId] = useWatch({
    control,
    name: triggerFields,
  });

  useEffect(() => {
    if (sourceEmployeeId !== undefined && sourceId !== undefined) trigger(triggerFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceEmployeeId, sourceId, trigger]);

  return (
    <>
      <CasRHFTextField name="name" label="Name" />
      <CasRHFAutocompleteAsync
        url="Hubspot/CompaniesAndContacts/List"
        name="crmCompositeObj"
        label={`${Terms.CRM.label} Contact/Company`}
      />
      {riskManagers?.length ? (
        <CasRHFSelect name="rmcOfRecordEmployeeId" label="Service Owner" options={riskManagers} />
      ) : (
        <CasRHFRiskManagerSelect includeBusDev name="rmcOfRecordEmployeeId" label="Service Owner" />
      )}
      <CasStackRow gapSize="none">
        <CasRHFRiskWithSalesManagerSelect
          includeNoneOption
          name="sourceEmployeeId"
          label="Source Employee"
        />
        <CasRHFSourceSelect name="sourceId" label="Type" includeNoneOption />
      </CasStackRow>
      { /* <CasRHFTextField name="grouping" label="Grouping" /> */ }
    </>
  );
}
